import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';

import {CartProvider} from "./context/CartContext";
import {HomePage} from "./app/HomePage";
import {TermsOfService} from "./pages/TermsOfService";
import {NotFound404} from "./pages/404NotFound";
import {AppHeader} from "./components/layout/AppHeader";
import {AppFooter} from "./components/layout/AppFooter";
import {PrivacyPolicy} from "./pages/PrivacyPolicy";
import {Library} from "./pages/Library";
import {Faq} from "./pages/Faq";
import {Account} from "./pages/Account";
import {CartSideBar} from "./components/common/CartSidebar";
import React from "react";
import {CreditModalProvider} from "./context/CreditModalContext";

export const App = () => {
    return (
        <Router>
            <CartProvider>
                <CreditModalProvider>
                    
                    <AppHeader/>
                    
                    <Routes>
                        <Route path="/" element={<HomePage/>}/>
                        <Route path="*" element={<NotFound404/>}/>
                        <Route path="/account" element={<Account/>}/>
                        <Route path="/library" element={<Library/>}/>
                        <Route path="/terms-of-service" element={<TermsOfService/>}/>
                        <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>
                        <Route path="/faq" element={<Faq/>}/>
                    </Routes>
    
                    <CartSideBar />
                    <AppFooter/>
                    
                </CreditModalProvider>
            </CartProvider>
        </Router>
    )
};





